export const constants = {
  SDGS_UN_URL: "https://sdgs.un.org/goals/goal",
  ACCOUNTING: "accounting",
  ADMIN: "admin",
  PORTFOLIO: "portfolio",
  PROJECTS: "projects",
  TRANSACTIONS: "transactions",
};
